/**
 * ICON_MAP - Mapeamento de ícones por chave
 *
 * Este arquivo existe separado para evitar dependências circulares
 * entre AgentsFlowCanvas.js e os componentes de nós.
 */

import {
  IconCalendarEvent,
  IconCalendarOff,
  IconCalendarSearch,
  IconCalendarTime,
  IconCalendarCheck,
  IconQuestionMark,
  IconBook,
  IconHeadset,
  IconClipboardList,
  IconBell,
  IconShoppingCart,
  IconBrain,
  IconClock,
  IconDatabase,
  IconMessage,
  IconApi,
  IconVariable,
  IconTarget,
  IconUserCheck,
  IconRepeat,
  IconTruck,
  IconForms,
  IconUserPlus,
  IconPlayerPause,
  IconSparkles,
  IconAlarm,
  IconPhoto,
  IconEye,
  IconRoute,
  IconMailSearch,
  IconFileSpreadsheet,
  IconBrandWhatsapp,
  IconMail,
} from '@tabler/icons-react';

export const ICON_MAP = {
  // Actions
  send_message: IconMessage,
  api_call: IconApi,
  set_variable: IconVariable,
  wait_for_input: IconAlarm,
  ai_response: IconSparkles,
  collect_field: IconForms,
  send_media: IconPhoto,
  send_whatsapp: IconBrandWhatsapp,
  send_email: IconMail,
  // Conditions
  intent: IconBrain,
  intent_router: IconRoute,
  time: IconClock,
  data_check: IconDatabase,
  // Core Capabilities
  scheduling: IconCalendarEvent,
  check_availability: IconCalendarSearch,
  cancellation: IconCalendarOff,
  reschedule: IconCalendarTime,
  appointment_confirmation: IconCalendarCheck,
  faq: IconBook,
  human_handoff: IconUserPlus,
  data_collection: IconForms,
  // Qualification Capabilities
  qualify_lead: IconTarget,
  // Automation Capabilities
  notifications: IconBell,
  presence_confirmation: IconUserCheck,
  followup_auto: IconRepeat,
  // Commerce Capabilities
  sales: IconShoppingCart,
  delivery_tracking: IconTruck,
  // Media Library
  media_library: IconPhoto,
  // Media Analysis
  media_analysis: IconEye,
  // Email Monitor
  email_monitor: IconMailSearch,
  // Sheets Reader
  sheets_reader: IconFileSpreadsheet,
};

export default ICON_MAP;
